// extracted by mini-css-extract-plugin
export default {"container":"HOT5C6YodDhYIVz2jFxddw==","headline":"HmxKtzbXaZQXFlf6BPwj-Q=="};